/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Callback_Sign_In_RequiredInputs */

const en_common_auth_callback_sign_in_required = /** @type {(inputs: Common_Auth_Callback_Sign_In_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please sign in to finish.`)
};

const zh_common_auth_callback_sign_in_required = /** @type {(inputs: Common_Auth_Callback_Sign_In_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先登录以完成操作。`)
};

/**
* | output |
* | --- |
* | "Please sign in to finish." |
*
* @param {Common_Auth_Callback_Sign_In_RequiredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_callback_sign_in_required = /** @type {((inputs?: Common_Auth_Callback_Sign_In_RequiredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Callback_Sign_In_RequiredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_callback_sign_in_required(inputs)
	return zh_common_auth_callback_sign_in_required(inputs)
});
export { common_auth_callback_sign_in_required as "common.auth.callback.sign_in_required" }